import React, { useState } from "react";
import { client } from "../../../../service/ApolloClient/ApolloClient";
import { QUERY_BANK_ACCOUNTS } from "../../../../service/ApolloClient/ApolloQueries";
import Wrapper from "../../../../hoc/Wrapper/Wrapper";
import { Box, Dialog, DialogTitle, IconButton } from "@material-ui/core";
import AutoCompleteMU from "../../../UI/AutoCompleteMU/AutoCompleteMU";
import AddIcon from "@material-ui/icons/Add";
import BankAccountAddModal from "../../../Form/BankAccountAddModal";

const BankSelect = (props) => {
  const { title, setFieldValue, value, fieldName, fieldNameShow } = props;
  const [keyword, setKeyword] = useState(props.value);
  const [modalOpen, setModalOpen] = useState(false);
  const query = client
    .query({
      query: QUERY_BANK_ACCOUNTS,
      variables: {
        search: keyword,
        limit: 20,
        page: 1,
      },
      fetchPolicy: "network-only",
    })
    .catch((err) => console.log(err));

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Wrapper>
      <Box display={"flex"} p={1}>
        <Box flexGrow={1}>
          <AutoCompleteMU
            fieldNameShow={"recieverable_name"}
            value={value ? value : ""}
            title={"انتخاب بانک"}
            setFieldValue={setFieldValue}
            keyword={keyword}
            setKeyword={setKeyword}
            query={query}
            queryName={"bankAccounts"}
            field={["bank", "branch", "user_fullname", "account"]}
            fieldSelect={"id"}
            fieldName={"recieverable_id"}
          />
        </Box>
        {props.disabledAdd ? null : (
          <Box>
            <IconButton
              onClick={(e) => {
                setModalOpen(!modalOpen);
              }}
            >
              <AddIcon />
            </IconButton>

            <Dialog
              open={modalOpen}
              onClose={handleClose}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">
                افزودن حساب بانکی
              </DialogTitle>
              <BankAccountAddModal handleClose={handleClose} />
            </Dialog>
          </Box>
        )}
      </Box>
    </Wrapper>
  );
};

export default React.memo(BankSelect);
